import { gql } from '@apollo/client'
import meetingDashboardFragment from './fragments/meetingDashboard.fragment'
import employeeDisplayShortInfoFragment from '../employee/fragments/employeeDisplayShortInfo.fragment'

export const MEETINGS_AND_REQUESTS_BY_REPLYER = gql`
  query MeetingsAndRequestsByReplyer($replyerId: HashedId!, $disputedMeetingsIncluded: Boolean = false) {
    meetingsByReplyer(replyerId: $replyerId, disputedMeetingsIncluded: $disputedMeetingsIncluded) {
      ...MeetingDashboard
    }
    getMeetingRequestsByRequester(requesterId: $replyerId) {
      id
      type
      requestedDate
      reasonForRequest
      reasonOfRejection
      status
      requester {
        id
        firstName
        lastName
      }
      reviewer {
        id
        firstName
        lastName
      }
      appraisalSeason {
        id
        companyId
        country
        year
        fromDate
        toDate
      }
      isRequestValid
    }
    employeeDisplayShortInfoByEmployeeId(id: $replyerId) {
      ...EmployeeDisplayShortInfo
    }
  }
  ${meetingDashboardFragment}
  ${employeeDisplayShortInfoFragment}
`

export const GET_MEETING_REQUESTS_BY_REVIEWER = gql`
  query GetMeetingRequestsByReviewer($reviewerId: HashedId!) {
    getMeetingRequestsByReviewer(reviewerId: $reviewerId) {
      id
      type
      requestedDate
      reasonForRequest
      reasonOfRejection
      status
      requester {
        id
        firstName
        lastName
      }
      reviewer {
        id
        firstName
        lastName
      }
      appraisalSeason {
        id
        companyId
        country
        year
        fromDate
        toDate
      }
      isRequestValid
    }
  }
`

export const GET_MEETING_REQUEST_BY_ID = gql`
  query GetMeetingRequest($meetingRequestId: HashedId!) {
    getMeetingRequest(meetingRequestId: $meetingRequestId) {
      id
      type
      requestedDate
      reasonForRequest
      reasonOfRejection
      status
      requester {
        id
        firstName
        lastName
      }
      reviewer {
        id
        firstName
        lastName
      }
      isRequestValid
    }
  }
`
export const GET_MEETING_REQUESTS_BY_COMPANY_COUNTRY = gql`
  query getMeetingRequestsByCompanyCountry($companyId: HashedId!, $country: String!) {
    getMeetingRequestsByCompanyCountry(companyId: $companyId, country: $country) {
      id
      type
      requestedDate
      reasonForRequest
      reasonOfRejection
      status
      requester {
        id
        firstName
        lastName
      }
      reviewer {
        id
        firstName
        lastName
      }
      appraisalSeason {
        id
        companyId
        country
        year
        fromDate
        toDate
      }
      isRequestValid
    }
  }
`
